import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import WarrantyInsert from './insert';
import WarrantyQuery from './query';

export const warrantiesRoutes = [
  {'component': <WarrantyInsert />, 'path': paths.WarrantyInsert},
  {'component': <WarrantyInsert />, 'path': paths.WarrantyUpdate},
  {'component': <WarrantyQuery />, 'path': paths.WarrantyQuery},
];
